module.exports = __webpack_public_path__ + "glyphicons-regular.924bd15c395212bc01d8.svg";


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/assets/css/fonts/glyphicons.pro/glyphicons-regular.svg
// module id = ../../../../../src/assets/css/fonts/glyphicons.pro/glyphicons-regular.svg
// module chunks = 2